export const ModuleCacheBusterSymbol = Symbol('ModuleCacheBuster')

/**
 * Gives builder module URLs (components and context providers) a new `t` query, so the next load imports the
 * module again instead of getting the one the browser already loaded from the same URL.
 */
export type IModuleCacheBuster = {
	/** Returns the url to import a builder module from: the url itself until `bustAll` is first called. */
	bustUrl: (url: string) => string
	/** Makes every builder module URL new, so the next page load imports them again (like a browser reload). */
	bustAll: () => void
}
